import { ordersApi } from './Api';
import { AxiosResponse } from "axios";

const OrderService = (() => {
	function reserve(cartId: string, userId: string, eventId: number, appType: string): Promise<AxiosResponse<any>> {
		return ordersApi.post(`/v2/public/checkout/seat-reservation`, { cartId, userId, eventId, appType });
	}

	function updateUserReserve(params: any) {
		return ordersApi.put(`/v2/checkout/reservation/user`, {}, { params });
	}

	return {
		reserve: reserve,
		updateUserReserve: updateUserReserve
	}
})();

export default OrderService;
